module.exports = __webpack_public_path__ + "img/protect.47f0b0f9.svg";